export default "__VITE_ASSET___4I0v_k8__"